import { Button } from '@/shadcn/button';

import { getIsAllSelected, useSelectableItemsContext } from '..';

export const SelectAllButton = () => {
  const selectableItemsContext = useSelectableItemsContext();

  if (!selectableItemsContext) return null;

  const { handleSelectAll, treeValue } = selectableItemsContext;

  const isAllSelected = getIsAllSelected(treeValue);

  const handleClick = () => {
    handleSelectAll(!isAllSelected);
  };

  return (
    <div>
      <Button onClick={handleClick} variant="pushtextMuted">
        {isAllSelected ? 'Unselect all' : 'Select all'}
      </Button>
    </div>
  );
};
